import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMegaphone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M2 8.00004C2 8.00004 1.5 7.81254 1.5 7.00004C1.5 6.18754 2 6.00004 2 6.00004M14 7.68754C14 7.68754 14.5 7.55223 14.5 7.00004C14.5 6.44786 14 6.31254 14 6.31254M8 5.00004V9.00004M3.5 5.00004V9.00004M12.7481 1.63192C12.7481 1.63192 10.0406 5.00004 7.5 5.00004H2.5C2.36739 5.00004 2.24021 5.05272 2.14645 5.14649C2.05268 5.24026 2 5.36743 2 5.50004V8.50004C2 8.63265 2.05268 8.75983 2.14645 8.8536C2.24021 8.94736 2.36739 9.00004 2.5 9.00004H7.5C10.0406 9.00004 12.7481 12.3822 12.7481 12.3822C12.9375 12.6322 13.5 12.461 13.5 12.075V1.93754C13.5 1.55286 12.9688 1.34942 12.7481 1.63192Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Vector_2",
		d: "M4.5 9V14.25C4.5 14.3163 4.52634 14.3799 4.57322 14.4268C4.62011 14.4737 4.6837 14.5 4.75 14.5H6.40625C6.48458 14.5 6.56181 14.4816 6.63173 14.4464C6.70165 14.4111 6.7623 14.3598 6.8088 14.2968C6.85529 14.2338 6.88632 14.1607 6.8994 14.0835C6.91247 14.0062 6.90722 13.927 6.88406 13.8522C6.62219 13.0122 6 12.065 6 10.5H6.5C6.63261 10.5 6.75979 10.4473 6.85355 10.3536C6.94732 10.2598 7 10.1326 7 10V9.5C7 9.36739 6.94732 9.24021 6.85355 9.14645C6.75979 9.05268 6.63261 9 6.5 9H6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgMegaphone;
